import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.0.8_@vue+compiler-sfc@3.5.26_cac@6.7.1_ca18fcc40b094d04ab0d3300b203aa31/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}